// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftOffset {
  position: relative;
  left: 11px; }
  .leftOffset::after {
    content: ':';
    margin-left: 2px; }

.wrap {
  position: relative;
  top: 3px;
  text-wrap: wrap; }

.labelWithOffset {
  position: relative;
  left: 12px;
  white-space: pre-line; }

.offset {
  margin-left: 0px;
  position: absolute;
  right: -32px;
  top: 7px; }

.dragDropContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 10px;
  row-gap: 10px; }

.tag {
  display: inline-block;
  padding: 5px 10px;
  border: 3px solid #f4f5f4;
  border-radius: 5px;
  cursor: move; }

.dragDroplabel {
  min-height: 70px; }

.mti-container {
  display: flex; }

.extraIcons {
  position: absolute;
  left: calc(100% + 5px);
  display: flex;
  align-items: center;
  column-gap: 10px;
  height: 100%; }

.dragger {
  cursor: move; }

.uploadContainer {
  display: grid;
  column-gap: 10px; }

.dynamic-delete-button {
  color: #999;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s; }

.dynamic-delete-button:hover {
  color: #777; }

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5; }

[data-theme='dark'] .dynamic-delete-button {
  color: rgba(255, 255, 255, 0.45); }

[data-theme='dark'] .dynamic-delete-button:hover {
  color: rgba(255, 255, 255, 0.65); }
`, "",{"version":3,"sources":["webpack://./src/components/style.scss"],"names":[],"mappings":"AAAA;EACI,kBAAkB;EAClB,UAAU,EAAA;EAFd;IAKQ,YAAY;IACZ,gBAAgB,EAAA;;AAIxB;EACI,kBAAkB;EAClB,QAAQ;EACR,eAAe,EAAA;;AAGnB;EACI,kBAAkB;EAClB,UAAU;EACV,qBAAqB,EAAA;;AAIzB;EACI,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,QAAQ,EAAA;;AAIZ;EACI,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,aAAa,EAAA;;AAGjB;EACI,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY,EAAA;;AAGhB;EACI,gBAAgB,EAAA;;AAIpB;EACI,aAAa,EAAA;;AAEjB;EACI,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY,EAAA;;AAEhB;EACI,YAAY,EAAA;;AAEhB;EACI,aAAa;EACb,gBAAgB,EAAA;;AAIpB;EACI,WAAW;EACX,eAAe;EACf,eAAe;EACf,oBAAoB,EAAA;;AAExB;EACI,WAAW,EAAA;;AAEf;EACI,mBAAmB;EACnB,YAAY,EAAA;;AAZhB;EAeI,gCAAgC,EAAA;;AAZpC;EAeI,gCAAgC,EAAA","sourcesContent":[".leftOffset {\n    position: relative;\n    left: 11px;\n\n    &::after {\n        content: ':';\n        margin-left: 2px;\n    }\n}\n\n.wrap {\n    position: relative;\n    top: 3px;\n    text-wrap: wrap;\n}\n\n.labelWithOffset {\n    position: relative;\n    left: 12px;\n    white-space: pre-line;\n}\n\n// used in multipleTwinInput form field\n.offset {\n    margin-left: 0px;\n    position: absolute;\n    right: -32px;\n    top: 7px;\n}\n\n// used in multiSelectInput component\n.dragDropContainer {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    column-gap: 10px;\n    row-gap: 10px;\n}\n\n.tag {\n    display: inline-block;\n    padding: 5px 10px;\n    border: 3px solid #f4f5f4;\n    border-radius: 5px;\n    cursor: move;\n}\n\n.dragDroplabel {\n    min-height: 70px;\n}\n\n// used in multipleTextInput component\n.mti-container {\n    display: flex;\n}\n.extraIcons {\n    position: absolute;\n    left: calc(100% + 5px);\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    height: 100%;\n}\n.dragger {\n    cursor: move;\n}\n.uploadContainer {\n    display: grid;\n    column-gap: 10px;\n}\n\n// used in multipleTextInput and multipleTwinInpput form field\n.dynamic-delete-button {\n    color: #999;\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n.dynamic-delete-button:hover {\n    color: #777;\n}\n.dynamic-delete-button[disabled] {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n[data-theme='dark'] .dynamic-delete-button {\n    color: rgba(255, 255, 255, 0.45);\n}\n[data-theme='dark'] .dynamic-delete-button:hover {\n    color: rgba(255, 255, 255, 0.65);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
